<template>
  <div class="main-container">
    <div v-if="showIntro && (!legalEntityList.length)">
      <tl-header type="h1">
        <div>Legal Entities</div>
        <template slot="icon">
          <div class="showIntro" @click="goToIntro">
            <img src="@/assets/questionmark.png" />
          </div>
        </template>
      </tl-header>
      <div class="row-container center">
        <div class="company-info">
          <br />
          <img class="image" src="@/assets/legalEntity.svg" />
          <div class="fontStyle">
            <div @click="goToLegalEntitiesPage">
              <img class="closeImage" src="@/assets/close.png" />
            </div>
            <div>An association, corporation, partnership, proprietorship, trust, or individual that has legal standing in the eyes of law.</div>
            <div
              class="margin-t-l"
            >A legal entity has legal capacity to enter into agreements or contracts, assume obligations, incur and pay debts, sue and be sued in its own right, and to be held responsible for its actions.</div>
            <div class="divider"></div>
            <btn
              text="Get Started"
              class="margin-t-m"
              type="secondary"
              @click="goToLegalEntitiesPage"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <legal-entities v-show="allle" :lelist="legalEntityList" />
    </div>
  </div>
</template>

<script>
import LegalEntities from "./legal_entities.vue";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "LegalEntitiesIntro",
  data() {
    return {
      showIntro: true,
      allle: true,
      legalEntityList: []
    };
  },
  components: {
    LegalEntities
  },
  activated: function() {
    // with org_id
    this.fetchLegalEntities(this.orgId);
  },
  computed: {
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    })
  },
  methods: {
    ...mapActions({
      fetch: "onboard/legal_entities/fetchAll"
    }),
    goToIntro() {
      this.showIntro = true;
    },
    goToLegalEntitiesPage() {
      this.showIntro = false;
      if (this.legalEntityList.length) {
        this.allle = true;
      } else {
        this.$router.push({
          path: "/onboarding/legal_entities/addLegalEntity"
        });
      }
    },
    async fetchLegalEntities(id) {
      try {
        let res = await this.fetch(id);
        if(res.data.status){
          this.legalEntityList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.row-container {
  .value {
    margin-right: 0;
  }
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
}

.image {
  margin-top: 30px;
}

.closeImage {
  float: right;
  margin: -10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 100%;
  margin: 30px 0 0 5px;
}
</style>
